import { useState } from 'react';
import { Button } from '@belong/ui';
import type { MaintenanceQuoteRejectionReason } from 'maintenance/types/quote-centric';
import { STRINGS } from 'maintenance/strings';
import { QuoteQuestionsModal } from './QuoteQuestionsModal';

type QuoteDecisionFooterProps = {
  isUpdating: boolean;
  onApprove: () => void;
  onQuestionsSubmit: (
    rejectionReason: MaintenanceQuoteRejectionReason,
    notes?: string,
  ) => Promise<boolean>;
};

export const QuoteDecisionFooter = ({
  isUpdating,
  onApprove,
  onQuestionsSubmit,
}: QuoteDecisionFooterProps) => {
  const [isQuestionsModalOpen, setIsQuestionsModalOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col-reverse items-center gap-lg rounded-b bg-dark-navy p-sm sm:flex-row sm:justify-between sm:gap-sm">
        <Button
          variant="text"
          buttonType="light"
          onClick={() => setIsQuestionsModalOpen(true)}
          disabled={isUpdating}
        >
          {STRINGS['quote-questions']}
        </Button>
        <Button
          size="auto"
          className="w-full sm:w-[160px]"
          onClick={onApprove}
          disabled={isUpdating}
        >
          {STRINGS['quote-approve']}
        </Button>
      </div>
      <QuoteQuestionsModal
        isOpen={isQuestionsModalOpen}
        isSubmitting={isUpdating}
        onDismiss={() => setIsQuestionsModalOpen(false)}
        onSubmit={async (rejectionReason, notes) => {
          if (await onQuestionsSubmit(rejectionReason, notes)) {
            setIsQuestionsModalOpen(false);
          }
        }}
      />
    </>
  );
};
